import "./PopNotActive.scoped.scss";
import React from "react";
import useStore from "core/custom-hooks/useStore";
import { setPopup } from "core/store/actionCreators";

const CustomerPopNotActive = ({ type }) => {
    const { dispatch } = useStore(); // קריאה ל-useStore בתוך גוף הקומפוננטה

    const handleClose = () => {
        dispatch(setPopup({ isOpen: false }));
    };

    return (
        <div 
            className="popup-overlay"
            role="dialog"
            aria-modal="true"
        >
            <div 
                className="popup-backdrop"
                onClick={handleClose}
                aria-hidden="true"
            />
            <div 
                className="popup-content"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="popup-body">
                    <div className="icon-wrapper">
                        <div className="icon-glow" />
                        <div className="icon-circle">
                            <svg className="icon-svg" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="10"/><line x1="12" x2="12" y1="8" y2="12"/><line x1="12" x2="12.01" y1="16" y2="16"/>
                            </svg>
                        </div>
                    </div>

                    <h2 className="popup-title">
                        שים לב
                    </h2>
                    
                    <div className="title-underline" />
                    
                    <p className="popup-message">
                        {type !== "ררח" && " עסק זה לא פעיל כרגע."}
                        {type === "ררח" && "פרסום חינמי- גישה מוגבלת"}
                    </p>

                    <button
                        onClick={handleClose}
                        className="action-btn"
                    >
                        הבנתי, תודה
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CustomerPopNotActive;